import { render, staticRenderFns } from "./welcome2.vue?vue&type=template&id=8e19842a&scoped=true&"
import script from "./welcome2.vue?vue&type=script&lang=js&"
export * from "./welcome2.vue?vue&type=script&lang=js&"
import style0 from "./welcome2.vue?vue&type=style&index=0&id=8e19842a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e19842a",
  null
  
)

export default component.exports